export default __webpack_public_path__ + "static/vr-5232109089f6bd7ca2a5dd0ed291621f.jpg";